import type { ReactElement, ReactNode } from "react";
import { space } from "@tokens/index";
import { useViewport } from "@primitives/index";

/**
 * FormActions: the action row of a form.
 *
 * `medium`+ right-aligns the primary action after the secondary one.
 * `compact` stacks every action at full width, primary first.
 */

interface FormActionsProps {
    readonly primary: ReactNode;
    readonly secondary?: ReactNode;
    /** Validation or status text that sits before the actions. */
    readonly note?: ReactNode;
}

export function FormActions({ primary, secondary, note }: FormActionsProps): ReactElement {
    const { isCompact } = useViewport();

    if (isCompact) {
        return (
            <div style={{ display: "grid", gap: space[2], width: "100%" }}>
                {primary}
                {secondary}
                {note}
            </div>
        );
    }

    return (
        <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: space[2],
            }}
        >
            {note !== undefined && <div style={{ flex: 1, minWidth: 0 }}>{note}</div>}
            {secondary}
            {primary}
        </div>
    );
}
